/*
 * @providesModule MatchmakingConstants
 */

export const MatchmakingConstants = {
  SEARCHING_FOR_OPPONENT: 'SEARCHING_FOR_OPPONENT',
  OPPONENT_FOUND: 'OPPONENT_FOUND',
  WAITING_FOR_OPPONENT: 'WAITING_FOR_OPPONENT',
  OPPONENT_CANCELLED: 'OPPONENT_CANCELLED',
  STARTING_GAME: 'STARTING_GAME',
  OVERTIME_GAME: 'OVERTIME_GAME',
  NOT_ACTIVE: 'NOT_ACTIVE',
  START_SYNC_SEARCHING: 'START_SYNC_SEARCHING',
  SYNC_WAIT_TIME_EXCEEDED: 'SYNC_WAIT_TIME_EXCEEDED',
} as const;
